import React, { useState } from 'react';
import { Typography } from '@mui/material';
import { CalendarIcon, DownloadIcon, FileTextIcon, MapIcon, UsersIcon, CreditCardIcon } from 'lucide-react';
import TransactionDetailReport from './TransactionDetailReport';
import CountryWiseReport from './CountryWiseReport';
import AgentWiseReport from './AgentWiseReport';
import PaymentModeReport from './PaymentModeReport';
type ReportType = 'transaction' | 'country' | 'agent' | 'payment';
const ReportsPage: React.FC = () => {
  const [reportType, setReportType] = useState<ReportType>('transaction');
  const [dateRange, setDateRange] = useState({
    from: '',
    to: ''
  });
  const [isGeneratingReport, setIsGeneratingReport] = useState(false);
  const [reportGenerated, setReportGenerated] = useState(false);
  const handleGenerateReport = (e: React.FormEvent) => {
    e.preventDefault();
    setIsGeneratingReport(true);
    // Simulate API delay
    setTimeout(() => {
      setIsGeneratingReport(false);
      setReportGenerated(true);
    }, 1000);
  };
  return <div className="p-6 bg-gray-50 min-h-screen" data-id="element-2369">
      <div className="flex items-center gap-3 mb-6" data-id="element-2370">
        <FileTextIcon className="h-7 w-7" color="#0052CC" data-id="element-2371" />
        <Typography variant="h4" sx={{
        fontWeight: 700,
        color: '#0052CC'
      }} data-id="element-2372">
          Reports
        </Typography>
      </div>
      <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-4 mb-6" data-id="element-2373">
        <div className={`p-4 rounded-lg border ${reportType === 'transaction' ? 'border-blue-500 bg-blue-50' : 'border-gray-200 bg-white'} cursor-pointer hover:bg-blue-50 transition-colors`} onClick={() => setReportType('transaction')} data-id="element-2374">
          <div className="flex items-center" data-id="element-2375">
            <div className={`p-2 rounded-full ${reportType === 'transaction' ? 'bg-blue-100' : 'bg-gray-100'}`} data-id="element-2376">
              <FileTextIcon className={`h-6 w-6 ${reportType === 'transaction' ? 'text-blue-600' : 'text-gray-500'}`} data-id="element-2377" />
            </div>
            <div className="ml-3" data-id="element-2378">
              <h3 className={`text-sm font-medium ${reportType === 'transaction' ? 'text-blue-700' : 'text-gray-700'}`} data-id="element-2379">
                Transaction Detail Report
              </h3>
              <p className="text-xs text-gray-500" data-id="element-2380">
                Detailed view of all transactions
              </p>
            </div>
          </div>
        </div>
        <div className={`p-4 rounded-lg border ${reportType === 'country' ? 'border-blue-500 bg-blue-50' : 'border-gray-200 bg-white'} cursor-pointer hover:bg-blue-50 transition-colors`} onClick={() => setReportType('country')} data-id="element-2381">
          <div className="flex items-center" data-id="element-2382">
            <div className={`p-2 rounded-full ${reportType === 'country' ? 'bg-blue-100' : 'bg-gray-100'}`} data-id="element-2383">
              <MapIcon className={`h-6 w-6 ${reportType === 'country' ? 'text-blue-600' : 'text-gray-500'}`} data-id="element-2384" />
            </div>
            <div className="ml-3" data-id="element-2385">
              <h3 className={`text-sm font-medium ${reportType === 'country' ? 'text-blue-700' : 'text-gray-700'}`} data-id="element-2386">
                Sending Country Wise Report
              </h3>
              <p className="text-xs text-gray-500" data-id="element-2387">
                Transactions grouped by country
              </p>
            </div>
          </div>
        </div>
        <div className={`p-4 rounded-lg border ${reportType === 'agent' ? 'border-blue-500 bg-blue-50' : 'border-gray-200 bg-white'} cursor-pointer hover:bg-blue-50 transition-colors`} onClick={() => setReportType('agent')} data-id="element-2388">
          <div className="flex items-center" data-id="element-2389">
            <div className={`p-2 rounded-full ${reportType === 'agent' ? 'bg-blue-100' : 'bg-gray-100'}`} data-id="element-2390">
              <UsersIcon className={`h-6 w-6 ${reportType === 'agent' ? 'text-blue-600' : 'text-gray-500'}`} data-id="element-2391" />
            </div>
            <div className="ml-3" data-id="element-2392">
              <h3 className={`text-sm font-medium ${reportType === 'agent' ? 'text-blue-700' : 'text-gray-700'}`} data-id="element-2393">
                Sending Agent Wise Report
              </h3>
              <p className="text-xs text-gray-500" data-id="element-2394">
                Transactions grouped by agent
              </p>
            </div>
          </div>
        </div>
        <div className={`p-4 rounded-lg border ${reportType === 'payment' ? 'border-blue-500 bg-blue-50' : 'border-gray-200 bg-white'} cursor-pointer hover:bg-blue-50 transition-colors`} onClick={() => setReportType('payment')} data-id="element-2395">
          <div className="flex items-center" data-id="element-2396">
            <div className={`p-2 rounded-full ${reportType === 'payment' ? 'bg-blue-100' : 'bg-gray-100'}`} data-id="element-2397">
              <CreditCardIcon className={`h-6 w-6 ${reportType === 'payment' ? 'text-blue-600' : 'text-gray-500'}`} data-id="element-2398" />
            </div>
            <div className="ml-3" data-id="element-2399">
              <h3 className={`text-sm font-medium ${reportType === 'payment' ? 'text-blue-700' : 'text-gray-700'}`} data-id="element-2400">
                Payment Mode Wise Report
              </h3>
              <p className="text-xs text-gray-500" data-id="element-2401">
                Transactions grouped by payment mode
              </p>
            </div>
          </div>
        </div>
      </div>
      <div className="bg-white rounded-lg shadow p-6 mb-6" data-id="element-2402">
        <h2 className="text-lg font-semibold text-gray-900 mb-4" data-id="element-2403">
          Report Parameters
        </h2>
        <form onSubmit={handleGenerateReport} data-id="element-2404">
          <div className="grid grid-cols-1 md:grid-cols-2 gap-6 mb-6" data-id="element-2405">
            <div data-id="element-2406">
              <label htmlFor="date-from" className="flex items-center text-sm font-medium text-gray-700 mb-2" data-id="element-2407">
                <CalendarIcon className="h-4 w-4 mr-2" data-id="element-2408" />
                Date From
              </label>
              <input type="date" id="date-from" className="w-full px-4 py-2.5 border border-gray-300 rounded-lg focus:ring-2 focus:ring-blue-500 focus:border-blue-500 transition-colors" value={dateRange.from} onChange={e => setDateRange({
              ...dateRange,
              from: e.target.value
            })} required data-id="element-2409" />
            </div>
            <div data-id="element-2410">
              <label htmlFor="date-to" className="flex items-center text-sm font-medium text-gray-700 mb-2" data-id="element-2411">
                <CalendarIcon className="h-4 w-4 mr-2" data-id="element-2412" />
                Date To
              </label>
              <input type="date" id="date-to" className="w-full px-4 py-2.5 border border-gray-300 rounded-lg focus:ring-2 focus:ring-blue-500 focus:border-blue-500 transition-colors" value={dateRange.to} onChange={e => setDateRange({
              ...dateRange,
              to: e.target.value
            })} required data-id="element-2413" />
            </div>
          </div>
          <div className="flex justify-end" data-id="element-2414">
            <button type="submit" className="inline-flex items-center px-6 py-2.5 border border-transparent text-sm font-semibold rounded-lg shadow-sm text-white bg-blue-600 hover:bg-blue-700 focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-blue-500 disabled:opacity-50 disabled:cursor-not-allowed transition-colors" disabled={isGeneratingReport || !dateRange.from || !dateRange.to} data-id="element-2415">
              {isGeneratingReport ? <>
                  <div className="animate-spin mr-2 h-4 w-4 border-2 border-white border-t-transparent rounded-full" data-id="element-2416"></div>
                  Generating...
                </> : <>Generate Report</>}
            </button>
          </div>
        </form>
      </div>
      {reportGenerated && <div className="bg-white rounded-lg shadow overflow-hidden" data-id="element-2417">
          <div className="px-4 py-3 border-b border-gray-200 flex justify-between items-center" data-id="element-2418">
            <h2 className="text-lg font-medium text-gray-700" data-id="element-2419">
              {reportType === 'transaction' && 'Transaction Detail Report'}
              {reportType === 'country' && 'Sending Country Wise Report'}
              {reportType === 'agent' && 'Sending Agent Wise Report'}
              {reportType === 'payment' && 'Payment Mode Wise Report'}
            </h2>
            <button type="button" className="inline-flex items-center px-3 py-1 border border-gray-300 text-sm font-medium rounded-md shadow-sm text-gray-700 bg-white hover:bg-gray-50 focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-blue-500" data-id="element-2420">
              <DownloadIcon className="h-4 w-4 mr-1" data-id="element-2421" />
              Export
            </button>
          </div>
          <div className="p-4" data-id="element-2422">
            {reportType === 'transaction' && <TransactionDetailReport dateRange={dateRange} data-id="element-2423" />}
            {reportType === 'country' && <CountryWiseReport dateRange={dateRange} data-id="element-2424" />}
            {reportType === 'agent' && <AgentWiseReport dateRange={dateRange} data-id="element-2425" />}
            {reportType === 'payment' && <PaymentModeReport dateRange={dateRange} data-id="element-2426" />}
          </div>
        </div>}
    </div>;
};
export default ReportsPage;